export default __webpack_public_path__ + "99e3b5beb7f37325c09822870af30f45.svg";